import { render, staticRenderFns } from "./LabelHeaderAddPage.vue?vue&type=template&id=1fb902a8&scoped=true&"
import script from "./LabelHeaderAddPage.vue?vue&type=script&lang=ts&"
export * from "./LabelHeaderAddPage.vue?vue&type=script&lang=ts&"
import style0 from "./LabelHeaderAddPage.vue?vue&type=style&index=0&id=1fb902a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb902a8",
  null
  
)

export default component.exports